export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 120 },
  { key: '3', headerName: 'Audit Sub Category', field: 'audit_subcategory', hide: false, width: 750 },
  { key: '4', headerName: 'Category', field: 'auditcategory_name', hide: false, width: 250 }

];
